import { z } from 'zod';

import { emailSchema, nameSchema } from 'utils/validators';

export const waitlistSchema = z.object({
  name: nameSchema,
  email: emailSchema,
  phone: z.string().optional(),
});

export type WaitlistFormValues = z.infer<typeof waitlistSchema>;
